import { Card, StyleProps, CardProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { CardLayouts, CardOutline, CardVariants } from './cardTheme';

export type CardContainerProps = CardProps & {
  variant: CardVariants;
  children: ReactNode;
  layout: CardLayouts;
  reverseHorizontalLayout?: boolean;
  cardOutline: CardOutline;
  mobileHorizontalLayout?: boolean;
};

/** 
  @deprecated - This component is being deprecated in favor of the `CardOutline` component. The reason is because
  the colorStrip with a border does not work. The Card (and CardContainer) is built in a way that is specific to Banner Cards.
  If you need a CardContainer on its own, use the `CardOutline` component instead.
*/

const CardContainer = (props: CardContainerProps) => {
  const {
    children,
    variant,
    layout,
    reverseHorizontalLayout,
    cardOutline = 'drop-shadow',
    mobileHorizontalLayout = false,
    ...restProps
  } = props;

  const dropShadowStyles: StyleProps = {
    boxShadow: 'card.light'
  };
  const borderStyles: StyleProps = {
    border: '2px solid #E5E5E5'
  };
  const outlineStyles = cardOutline === 'drop-shadow' ? dropShadowStyles : borderStyles;

  const layoutStyles: StyleProps =
    layout === 'horizontal'
      ? {
          flexDirection: {
            base: mobileHorizontalLayout ? 'row' : 'column',
            md: reverseHorizontalLayout ? 'row-reverse' : 'row'
          },
          gap: { base: mobileHorizontalLayout ? 0 : 6, md: 6 }
        }
      : {};

  return (
    <Card variant={variant} {...layoutStyles} {...outlineStyles} {...restProps}>
      {children}
    </Card>
  );
};

export { CardContainer };
